import { render, staticRenderFns } from "./admin-alerts.vue?vue&type=template&id=99d459b6&scoped=true&"
import script from "./admin-alerts.vue?vue&type=script&lang=js&"
export * from "./admin-alerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d459b6",
  null
  
)

export default component.exports